module.exports = __webpack_public_path__ + "05_medium_gold.3aed0088.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/05_medium_gold.png
// module id = i3/f
// module chunks = 0